import { Component, OnInit } from '@angular/core';
import { ISession } from '../../../models/session';
import { SessionBase } from '../session-base';
import { ActivatedRoute } from '@angular/router';
import { keys, reduce, assoc, concat, find, propEq } from 'ramda';
import { TranslateService } from '@ngx-translate/core';
import readXlsxFile from 'read-excel-file';
import { LiveeTagsService } from '../livee.tags.service';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { first, tap } from 'rxjs/operators';
import { LiveeFilesService } from '../livee.files.service';
import { forkJoin } from 'rxjs/observable/forkJoin';

const FEATURES_TAG = 'session.features';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss']
})
export class SessionsContentLiveeComponent extends SessionBase implements OnInit {
  public session: ISession;
  public loaded = false;
  public previewHash;
  public liveeTags: any = {};

  public musicNames = [
    'administratif01', 
    'administratif02', 
    'calme01', 
    'calme02', 
    'corporate01', 
    'corporate02', 
    'detente01', 
    'detente02', 
    'energique01', 
    'energique02', 
    'enfance01', 
    'enfance02', 
    'fashion01', 
    'fashion02', 
    'medical01', 
    'medical02', 
    'motivation01', 
    'motivation02', 
    'technologie01', 
    'technologie02'];

  public schemas = {
    schedule: {
      date: { prop: 'date', type: String },
      hour: { prop: 'hour', type: String },
      title: { prop: 'title', type: String },
      description: { prop: 'description', type: String },
      room: { prop: 'room', type: String },
      sessionid: { prop: 'sessionid', type: String }
    },
    speakers: {
      lastname: { prop: 'lastname', type: String },
      firstname: { prop: 'firstname', type: String },
      job: { prop: 'job', type: String },
      avatar: { prop: 'avatar', type: String },
      description: { prop: 'description', type: String },
      twitter: { prop: 'twitter', type: String },
      linkedin: { prop: 'linkedin', type: String },
      website: { prop: 'website', type: String },
      displayInHomepage: { prop: 'displayInHomepage', type: String }
    },
    sponsors: {
      name: { prop: 'name', type: String },
      logo: { prop: 'logo', type: String },
      category: { prop: 'category', type: String },
      website: { prop: 'website', type: String },
      description: { prop: 'description', type: String },
    },
    documents: {
    }
  }

  public parseExcel = schemaName => (f: File, cb: Function) => {
    readXlsxFile(f, { schema: this.schemas[schemaName] })
      .then(({ rows, errors }) => {
        if (errors.length === 0) {
          const value = {}; 
          value[ schemaName ] = rows;
          cb(null, value);
        } else {
          toastr.error(this.translateService.instant('action.failed'));
          cb(errors);
        }
      })
      .catch(e => {
        toastr.error(this.translateService.instant('action.failed'));
        cb(e);
      });
  }

  public content_left = {
    simple_session: [
      { 
        label: 'sessions.content.session_info.title',
        controls: [
          { type: 'text', tagName: 'session.description', className: 'w100', label: 'sessions.content.session_info.session_title' },
          { type: 'textarea', tagName: 'session.presentation', className: 'w100', label: 'sessions.content.session_info.description' },
          { type: 'text', tagName: 'session.survey', className: 'w100', dependson: 'live_survey', label: 'sessions.content.session_info.survey_alias' },
          { type: 'text', tagName: 'session.replay.url', className: 'w100', label: 'sessions.content.session_info.replay_url' }
        ]
      },
      {
        label: 'sessions.content.stream.title',
        controls: [
          { type: 'text-or-file-var', subtype: 'text', tagName: 'eevent.config', tagVar: 'sessionStartingMessage', tagVar2: 'sessionStartingCustom', tagVar3: 'sessionStartingURL', parseFn: this.parseFileBase64, limit: 50, className: 'w100', label: 'sessions.content.stream.welcome_message', label2: 'sessions.content.stream.uplad_custom_image' },
          { type: 'text-or-file-var', subtype: 'text', tagName: 'eevent.config', tagVar: 'sessionPauseMessage', tagVar2: 'sessionPauseCustom', tagVar3: 'sessionPauseURL', parseFn: this.parseFileBase64, limit: 50, className: 'w100', label: 'sessions.content.stream.break_message', label2: 'sessions.content.stream.uplad_custom_image' },
          { type: 'text-or-file-var', subtype: 'text', tagName: 'eevent.config', tagVar: 'sessionClosingMessage', tagVar2: 'sessionClosingCustom', tagVar3: 'sessionClosingURL', parseFn: this.parseFileBase64, limit: 50, className: 'w100', label: 'sessions.content.stream.end_message', label2: 'sessions.content.stream.uplad_custom_image' },
          { type: 'text-or-file-var', subtype: 'select', tagName: 'eevent.config', tagVar: 'musiqueName', tagVar2: 'musiqueCustom', tagVar3: 'musiqueURL', options: this.musicNames, parseFn: this.parseFileBase64, limit: 50, className: 'w100', label: 'sessions.content.stream.music', label2: 'sessions.content.stream.uplad_custom_music' },
          { type: 'text-var', tagName: 'eevent.config', tagVar: 'tabPresentationTitle', limit: 15, className: 'w50', label: 'sessions.content.stream.presentation' },
          { type: 'text-var', tagName: 'eevent.config', tagVar: 'tabVideoTitle', limit: 15, className: ['spl', 'w50'], label: 'sessions.content.stream.video' },
          { type: 'text-var', tagName: 'eevent.config', tagVar: 'tabTagcloudTitle', limit: 15, className: 'w50', label: 'sessions.content.stream.tagcloud' },
          { type: 'text-var', tagName: 'eevent.config', tagVar: 'tabVoteTitle', limit: 15, className: ['spl', 'w50'], label: 'sessions.content.stream.vote' },
          { type: 'text-var', tagName: 'eevent.config', tagVar: 'tabChatTitle', limit: 15, className: 'w50', label: 'sessions.content.stream.chat' },
          { type: 'text-var', tagName: 'eevent.config', tagVar: 'tabPhotowallTitle', limit: 15, className: ['spl', 'w50'], label: 'sessions.content.stream.photo' },
          { type: 'text-var', tagName: 'eevent.config', tagVar: 'tabQuestionTitle', limit: 15, className: 'w50', label: 'sessions.content.stream.question' }
        ]
      }
    ],
    eevent_main: [
      {
        label: 'sessions.content.general.title',
        controls: [
          { type: 'text', tagName: 'eevent.title', className: 'w100', label: 'sessions.content.general.event_title' },
          { type: 'text', tagName: 'eevent.subtitle', className: 'w100', label: 'sessions.content.general.event_subtitles' },
          { type: 'textarea', tagName: 'eevent.presentation', className: 'w100', label: 'sessions.content.general.description' },
          { type: 'file', tagName: 'eevent.schedule', parseFn: this.parseExcel('schedule'), className: 'w50', label: 'sessions.content.general.schedule' },
          { type: 'file', tagName: 'eevent.speakers', parseFn: this.parseExcel('speakers'), className: ['spl', 'w50', 'm-b-md'], label: 'sessions.content.general.speakers' },
          { type: 'file', tagName: 'eevent.sponsors', parseFn: this.parseExcel('sponsors'), className: 'w50', label: 'sessions.content.general.sponsors' },
          { type: 'file', tagName: 'eevent.documents', parseFn: this.parseExcel('documents'), className: ['spl', 'w50', 'm-b-md'], label: 'sessions.content.general.documents' },
          { type: 'text', tagName: 'eevent.socials', className: 'w100', label: 'sessions.content.general.social_network.label' },
          { type: 'switch', tagName: 'eevent.config', tagVar: 'global_social_network', className: 'w100', tagVarLabel: 'sessions.content.general.global.social_network', label: 'sessions.content.general.global.label' },
          { type: 'switch', tagName: 'eevent.config', tagVar: 'global_livee_copyright', className: 'w100', tagVarLabel: 'sessions.content.general.global.livee_copyright' }
        ]
      }
    ],
    eevent_child: [
      { 
        label: 'sessions.content.session_info.title',
        controls: [
          { type: 'text', tagName: 'session.description',className: 'w100', label: 'sessions.content.session_info.session_title' },
          { type: 'textarea', tagName: 'session.presentation', className: 'w100', label: 'sessions.content.session_info.description' },
          { type: 'text', tagName: 'session.survey', className: 'w100', dependson: 'live_survey', label: 'sessions.content.session_info.survey_alias' },  
          { type: 'text', tagName: 'session.replay.url', className: 'w100', label: 'sessions.content.session_info.replay_url' }
        ]
      },
      {
        label: 'sessions.content.stream.title',
        controls: [
          { type: 'text-or-file-var', subtype: 'text', tagName: 'eevent.config', tagVar: 'sessionStartingMessage', tagVar2: 'sessionStartingCustom', tagVar3: 'sessionStartingURL', parseFn: this.parseFileBase64, limit: 50, className: 'w100', label: 'sessions.content.stream.welcome_message', label2: 'sessions.content.stream.uplad_custom_image' },
          { type: 'text-or-file-var', subtype: 'text', tagName: 'eevent.config', tagVar: 'sessionPauseMessage', tagVar2: 'sessionPauseCustom', tagVar3: 'sessionPauseURL', parseFn: this.parseFileBase64, limit: 50, className: 'w100', label: 'sessions.content.stream.break_message', label2: 'sessions.content.stream.uplad_custom_image' },
          { type: 'text-or-file-var', subtype: 'text', tagName: 'eevent.config', tagVar: 'sessionClosingMessage', tagVar2: 'sessionClosingCustom', tagVar3: 'sessionClosingURL', parseFn: this.parseFileBase64, limit: 50, className: 'w100', label: 'sessions.content.stream.end_message', label2: 'sessions.content.stream.uplad_custom_image' },
          { type: 'text-or-file-var', subtype: 'select', tagName: 'eevent.config', tagVar: 'musiqueName', tagVar2: 'musiqueCustom', tagVar3: 'musiqueURL', options: this.musicNames, parseFn: this.parseFileBase64, limit: 50, className: 'w100', label: 'sessions.content.stream.music', label2: 'sessions.content.stream.uplad_custom_music' },
          { type: 'text-var', tagName: 'eevent.config', tagVar: 'tabPresentationTitle', limit: 15, className: 'w50', label: 'sessions.content.stream.presentation' },
          { type: 'text-var', tagName: 'eevent.config', tagVar: 'tabVideoTitle', limit: 15, className: ['spl', 'w50'], label: 'sessions.content.stream.video' },
          { type: 'text-var', tagName: 'eevent.config', tagVar: 'tabTagcloudTitle', limit: 15, className: 'w50', label: 'sessions.content.stream.tagcloud' },
          { type: 'text-var', tagName: 'eevent.config', tagVar: 'tabVoteTitle', limit: 15, className: ['spl', 'w50'], label: 'sessions.content.stream.vote' },
          { type: 'text-var', tagName: 'eevent.config', tagVar: 'tabChatTitle', limit: 15, className: 'w50', label: 'sessions.content.stream.chat' },
          { type: 'text-var', tagName: 'eevent.config', tagVar: 'tabPhotowallTitle', limit: 15, className: ['spl', 'w50'], label: 'sessions.content.stream.photo' },
          { type: 'text-var', tagName: 'eevent.config', tagVar: 'tabQuestionTitle', limit: 15, className: 'w50', label: 'sessions.content.stream.question' }
        ]
      }
    ]
  };

  public content_right = {
    simple_session: [
      {
        label: 'sessions.common.preview.title',
        controls: [{ type: 'preview', label: 'sessions.common.preview.label' }]
      }
    ],
    eevent_main: [
      {
        label: 'sessions.content.navigation.title',
        controls: [{ type: 'pages', tagName: 'eevent.pages', label: 'sessions.content.navigation.pages.label' }]
      }
    ],
    eevent_child: [
      {
        label: 'sessions.common.preview.title',
        controls: [{ type: 'preview', label: 'sessions.common.preview.label' }]
      }
    ]
  };

  constructor(
    private route: ActivatedRoute,
    private liveeTagsService: LiveeTagsService,
    private translateService: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    super.getSession$(this.route.parent.data).subscribe(() => {
      this.loadLiveeTags(this.session.type);
    });
  }

  private loadLiveeTags(sessionType) {
    const l: any[] = this.content_left[sessionType] || [];
    const r: any[] = this.content_right[sessionType] || [];

    const tagNames = reduce(
      (acc, g: any) => {
        if (g.controls) {
          g.controls.forEach(c => {
            if (c.tagName) {
              acc = assoc(c.tagName, '', acc);
            }
          });
        }
        return acc;
      },
      {},
      concat(l, r)
    );

    this.liveeTagsService.loadTags(this.session, concat(keys(tagNames), [FEATURES_TAG])).subscribe(
      liveeTags => {
        this.liveeTags = liveeTags;
        this.previewHash = new Date().getTime();
        this.loaded = true;
      },
      err => {
        console.error(err);
        toastr.error(this.translateService.instant('action.failed'));
      }
    );
  }

  modified() {
    let modified = false;
    keys(this.liveeTags)
      .map(name => this.liveeTags[name])
      .forEach(liveeTag => {
        if (liveeTag.modified()) {
          modified = true;
        }
      });
    return modified;
  }

  save() {
    this.liveeTagsService
      .updateTags(this.session, this.liveeTags)
      .subscribe(
        () => {
          toastr.success(this.translateService.instant('action.success'));
        },
        () => {
          toastr.error(this.translateService.instant('action.failed'));
        }
      );
  }

  dependsOn(featureName: string) {
    if (featureName) {
      const ltag = this.liveeTags[FEATURES_TAG];
      if (ltag && Array.isArray(ltag.value)) {
        const feature = find(propEq('name', featureName), ltag.value);
        if (feature) {
          return feature.isActivated;
        }
      }
      return false;
    }
    return true;
  }

  parseFileBase64(file: File, cb) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const onLoadEnd = (next: ProgressEvent) => {
      const target: any = next.target;
      const b64image: string = target.result;
      cb(null, { name: file.name, data: b64image });
    };
    const fileReader$ = fromEvent(reader, 'loadend');
    fileReader$.pipe(first(), tap(onLoadEnd)).subscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/content-livee/content.component.ts